export const WorkUrls = {
  getWorks: 'get-works',
  getFeaturedWorks: 'get-featured-works',
  updatesWork: 'update-work',
  deleteWork: 'delete-work',
  addWork: 'add-work',
};

export const JobUrls = {
  getJobs: 'get-jobs',
  updatesJob: 'update-job',
  deleteJob: 'delete-job',
  addJob: 'add-job',
};

export const MailUrls = {
  addMail: 'add-mail',
};

export const BlogsUrls = {
  getBlogs: 'get-blogs',
  updatesJob: 'update-job',
  deleteJob: 'delete-job',
  addJob: 'add-job',
};

export const loadStates = {
  loading: 'loading',
  error: 'error',
  success: 'success',
};
